import { Grid, Modal, Typography } from "@mui/material";
import { GradientButton } from "components/GradientButton";
import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import api from "_api";
import CustomTable from "components/TableExplanded/Table";
import useColumns from "./columns/mainColumns";
import useColumnsTwo from "./columns/subColumns";
import useProductData from "./data/data";
import CustomPagination from "components/TableExplanded/Pagination";
import SearchBar from "components/TableExplanded/SearchBar";
import dayjs from "dayjs";
import UnderConstruction from "components/UnderConstruction";

const Permissions = ({ className }) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isViewModalOpen, setViewModalOpen] = React.useState(false);
  const [selectedProduct, setProduct] = React.useState(null);
  const [viewProduct, setViewProduct] = React.useState(null);
  const [searchQuery, setSearchQuery] = React.useState(""); // Store the search query

  const [fetchData, setFetchData] = React.useState();

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };
  const fetchProductData = async () => {
    try {
      const { data, isStatus } = await api.super_admin.getPermission();
      // console.log("datadis", data);
      if (isStatus) setFetchData(data);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };
  React.useEffect(() => {
    fetchProductData();
  }, []);
  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen
    // handleModalOpen
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  const filteredData = React.useMemo(() => {
    if (!searchQuery) return data; // If no search query, return all data

    return data.filter((row) => {
      return visibleColumns.some((column) => {
        const cellValue = row[column.accessor]?.toString()?.toLowerCase();
        return cellValue && cellValue.includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    // Check if event.target and event.target.value are defined
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      setSearchTerm(event.target.value.toLowerCase());
      setSearchQuery(event.target.value);
    } else {
      console.error("Event target or value is undefined");
    }
  };

  const handleClear = () => {
    setSearchTerm("");
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (<UnderConstruction />);
  // return (
  //   <div className={className}>
  //     <Grid container spacing={2} style={{ marginBottom: "16px" }}>
  //       <Grid
  //         item
  //         xs={12}
  //         sm={12}
  //         style={{
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "space-between",
  //         }}
  //       >
  //         <Typography component="div" style={{ fontSize: "32px" }}>
  //           สิทธิ์
  //         </Typography>
  //       </Grid>
  //     </Grid>

  //     <SearchBar
  //       columns={columns}
  //       searchTerm={setSearchTerm}
  //       visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
  //       handleSearchChange={handleSearchChange}
  //       handleClear={handleClear}
  //       fetchData={fetchData}
  //       QRCode={true}
  //     />

  //     <CustomTable
  //       columns={columns}
  //       columnsInside={columnsInside}
  //       searchTerm={searchTerm}
  //       data={filteredData.slice(
  //         page * rowsPerPage,
  //         page * rowsPerPage + rowsPerPage
  //       )}
  //     />
  //     <CustomPagination
  //       count={filteredData.length}
  //       page={page}
  //       rowsPerPage={rowsPerPage}
  //       onPageChange={handlePageChange}
  //       onRowsPerPageChange={handleRowsPerPageChange}
  //     />
  //   </div>
  // );
};
export default Permissions;
